/** @jsx jsx */
import { jsx } from 'theme-ui';
import { graphql, Link, useStaticQuery } from 'gatsby';

const TableOfContents = () => {
  // no need for async/await here, will be executed at build time
  const data = useStaticQuery(graphql`
    query {
      allPostsPage(sort: { fields: created, order: DESC }) {
        nodes {
          id
          title
          path
          created(formatString: "MMMM DD, YYYY")
          language
        }
      }
    }
  `);

  const isSpanish = typeof window !== "undefined"
    ? window.location.pathname.includes("/es/")
    || !!window.location.pathname.match(/^.*\/es$/)
    : false;
  
  const pages = data.allPostsPage.nodes.filter(el => isSpanish ? el.language === 'es' : el.language !== 'es');

  return (
    <div>
      <h2>All Posts</h2>
      <ul>
        {pages.map(({ id, path, title }) => (
          <li key={id}>
            <Link
              to={path}
              sx={{
                '&.active': {
                  fontStyle: 'italic',
                  textDecoration: 'none',
                  '::after': {
                    content: '" (currently viewing)"',
                  },
                },
              }}
              activeClassName="active"
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default TableOfContents;
